import React from 'react';
import { useSelector } from 'react-redux';
import { useToolboxButtons } from '../../hooks.web';
export default function SideToolbar() {
    const cfg = useSelector((state) => {
        const config = state['features/base/config'];
        return (config && typeof config === 'object' && 'sideToolbar' in config)
            ? config.sideToolbar
            : {};
    });
    const enabled = cfg?.enabled ?? true; // force-enabled fallback
    const buttonKeys = (cfg?.buttons && cfg.buttons.length) ? cfg.buttons : ['play360', 'poojasteps', 'golive', 'livetranslation'];
    const showOnMobile = cfg?.showOnMobile ?? true;
    // Check if user is on mobile device
    const isMobile = typeof window !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // Filter buttons based on device type
    const filteredButtonKeys = buttonKeys.filter(buttonKey => {
        if (isMobile) {
            // On mobile: hide 'play360' and 'poojasteps', show 'golive' and 'livetranslation'
            return buttonKey !== 'play360' && buttonKey !== 'poojasteps';
        }
        else {
            // On desktop: hide 'golive', show 'play360', 'poojasteps', and 'livetranslation'
            return buttonKey !== 'golive';
        }
    });
    const allButtons = useToolboxButtons();
    const isNarrow = typeof window !== 'undefined' && window.innerWidth <= 768;
    if (!enabled || (!showOnMobile && isNarrow)) {
        return null;
    }
    // Inline styles so it works even if CSS bundle wasn't rebuilt yet
    const containerStyle = {
        position: 'absolute',
        left: 16,
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        zIndex: 1000,
        pointerEvents: 'none'
    };
    const itemStyle = { pointerEvents: 'auto' };
    return (React.createElement("div", { className: 'side-toolbar', style: containerStyle }, [...filteredButtonKeys]
        .map(key => allButtons[key])
        .filter(Boolean)
        .map(btn => {
        const Content = btn.Content;
        return (React.createElement("div", { key: btn.key, className: 'side-toolbar__item', style: itemStyle },
            React.createElement(Content, null)));
    })));
}
